function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.222%",
  y1: "50%",
  x2: "100%",
  y2: "69.475%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5532",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "83.681%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "58.156%",
  y1: "90.092%",
  x2: "100%",
  y2: "9.908%",
  id: "f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5532",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "73.159%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "17.727%",
  y1: "50%",
  x2: "82.528%",
  y2: "78.96%",
  id: "i"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6137",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "50%",
  x2: "17.727%",
  y2: "50%",
  id: "j"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF914A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6137",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 .203h200v122H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.763 71.308h-.373l-.232-.002a111.215 111.215 0 0 0-.236 0 29.933 29.933 0 0 0-.921.012l.121-.003a13.157 13.157 0 0 0-.743.04l.088-.008a8.307 8.307 0 0 0-.488.052l.084-.011-.219.031.135-.02a4.275 4.275 0 0 0-1.032.262l.026-.01c-.051.02-.102.043-.152.066l.126-.056c-.06.025-.12.052-.176.08l.05-.024a2.506 2.506 0 0 0-.153.08l.103-.055a2.425 2.425 0 0 0-.153.083l.05-.028a2.294 2.294 0 0 0-.13.078l.08-.05c-.051.03-.101.063-.15.097l.07-.047a2.134 2.134 0 0 0-.14.1l.07-.053a2.08 2.08 0 0 0-.117.09l.048-.038c-.044.034-.086.07-.127.107l.079-.069a1.994 1.994 0 0 0-.134.12l.055-.051a1.968 1.968 0 0 0-.113.111l.058-.06a1.96 1.96 0 0 0-.106.113l.048-.053a1.964 1.964 0 0 0-.11.13l.062-.077a1.977 1.977 0 0 0-.106.135l.043-.058a2.015 2.015 0 0 0-.106.15l.063-.092a2.047 2.047 0 0 0-.093.14l.03-.048c-.032.05-.063.103-.092.157l.062-.109c-.03.05-.06.103-.087.157l-.075.167c-1.035 2.555 1.215 3.591 3.97 3.347a10.317 10.317 0 0 0 1.84-.34l.063-.017.075-.02a21.998 21.998 0 0 1 .508-.131l.129-.032c.125-.03.262-.063.409-.096 4.631-1.06 19.733-3.439 23.15 9.774l.046.202a3.366 3.366 0 0 1 .06.591l-.006-.167c.003.045.005.09.005.134v.147l-.004.094-.002.023a3.075 3.075 0 0 1-.01.119l-.006.056a3.027 3.027 0 0 1-.442 1.244 2.623 2.623 0 0 1-.092.14 3.111 3.111 0 0 1-.502.562 3.263 3.263 0 0 1-1.142.66l-.026.01a3.288 3.288 0 0 1-.712.148l-.038.003c-.049.005-.098.008-.148.01h-.01.01a3.363 3.363 0 0 1-.134.003l-.073-.001c-.034 0-.069-.002-.103-.004-.016 0-.031-.002-.046-.003a2.874 2.874 0 0 1-.367-.043 3.437 3.437 0 0 1-.271-.058l-.348-.088c-1.205-.3-2.279-.525-3.31-.66a17.113 17.113 0 0 0-1.885-.146l-.29-.003-.29.002a16.55 16.55 0 0 0-1.464.09c-.272.028-.548.064-.83.106-1.847.277-3.956.853-6.738 1.788-1.367.46-2.718.908-4.052 1.344l-.506.165-.737.24-.457.148c-40.411 13.062-65.203 15.198-82.148 8.01C13.618 92.686 0 73.869 0 51.838l.007-.857C.46 22.746 23.277 0 51.359 0h7.032c28.365 0 51.36 23.208 51.36 51.837l-.01.989a53.587 53.587 0 0 1-.22 3.908c.002 0 0 .004-.002.01-.028.313-.06.624-.095.934.02 1.034.452 2.678 2.746 3.682.746.247 1.503.514 2.277.807l.109.04c.25.095.495.192.735.29.93.378 1.79.78 2.654 1.273l.144.083.13.076c.428.248.821.5 1.18.752l.011.008.07.049c.122.087.24.174.355.261l-.261-.194.034.024c.064.047.127.093.188.14l.039.03c2.69 2.05 2.294 4.4.044 5.505l-.064.03a3.206 3.206 0 0 1-.151.069 7.395 7.395 0 0 1-.571.214l-.05.015a7.757 7.757 0 0 1-.815.214 10.283 10.283 0 0 1-1.157.176 14.156 14.156 0 0 1-.806.059 20.673 20.673 0 0 1-.791.024l-.55.003h-.161z",
  id: "c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.21 41.917c8.657-4.53 9.795-13.178 11.533-23.306.782-4.557 2.86-6.668 4.908-7.612 1.767-.813 1.818-3.337.037-4.119-1.24-.544-2.403-.78-3.487-.782h-.028c-6.345.009-9.986 8.007-10.506 8.931-1.13 2.009-3.32 3.792-4.994 1.793-.766-.916-.085-2.61.51-3.58 1.005-1.636-.332-3.685-2.222-3.43-9.247 1.246-19.83 11.033-17.68 23.511",
  id: "g"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-6.8%",
  y: "-9.1%",
  width: "113.6%",
  height: "118.2%",
  filterUnits: "objectBoundingBox",
  id: "e"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -8,
  dy: 4,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 1 0",
  in: "shadowInnerInner1"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-22.5%",
  y: "-25.1%",
  width: "145%",
  height: "150.3%",
  filterUnits: "objectBoundingBox",
  id: "h"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -3,
  dy: 9,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.638514404 0 0 0 0 0.294117647 0 0 0 1 0",
  in: "shadowInnerInner1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(42 47.965)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#d)",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#e)",
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M68.95 87.114c0 1.414-1.136 2.56-2.537 2.56s-2.537-1.146-2.537-2.56c0-1.414 1.136-2.56 2.537-2.56 1.4 0 2.536 1.146 2.536 2.56M86.945 87.114c0 1.414-1.135 2.56-2.536 2.56s-2.537-1.146-2.537-2.56c0-1.414 1.136-2.56 2.537-2.56 1.4 0 2.536 1.146 2.536 2.56",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.944 91.922c-4.16 0-7.531 3.404-7.531 7.602h15.063c0-4.198-3.372-7.602-7.532-7.602",
  fill: "#F4D100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.348 104.7c2.832 0 5.128-2.318 5.128-5.176H71.22c0 2.858 2.296 5.175 5.128 5.175",
  fill: "#F2A100"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M76.12 28.83s-4 2.998-9 16.995l61 2.999s-4-19.995-16-24.993c0 0-4.66-3.241-15.83-2.62 0 0-12.17.62-20.17 7.618z",
  fill: "#FFC663"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.642 39.438-2.521 6.387h59.658l-.698-6.387s-16.96-4.61-38.96-2.61c0 0-10.958.221-17.48 2.61",
  fill: "#31A496"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21 15.233)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#f)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#h)",
  xlinkHref: "#g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M93.12 50.823s48.277-2.858 57.52 37.99c0 0 27.48-8.998 19.48-24.993 0 0-17-26.993-98-19.995 0 0-54 4.999-51 27.992 0 0-1 8.998 22 16.996 0 0 7-34.99 50-37.99z",
  fill: "#FFC663"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#463B3B",
  strokeWidth: 5.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m127.121 104.808 44-83.977M180.61 24.766l-9.531 18.705c-2.621 5.145-8.976 7.208-14.121 4.587-5.146-2.622-7.211-8.976-4.59-14.12l9.53-18.706"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m6.88 11.697 23.241 4.999c3.234 0 5.879 2.645 5.879 5.878 0 3.232-2.645 5.877-5.879 5.877L6.88 23.453c-3.234 0-5.88-2.645-5.88-5.877 0-3.234 2.646-5.879 5.88-5.879zM12.326 0l23.241 4.999c3.234 0 5.88 2.645 5.88 5.878 0 3.232-2.646 5.877-5.88 5.877l-23.24-4.998c-3.235 0-5.88-2.646-5.88-5.878C6.446 2.645 9.091 0 12.326 0z",
  fill: "url(#i)",
  opacity: 0.1,
  transform: "translate(99 93.311)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.567 0c3.234 0 5.88 2.645 5.88 5.878 0 3.232-2.646 5.878-5.88 5.878l-4.626-.001c2.85.401 5.059 2.865 5.059 5.82 0 3.233-2.645 5.878-5.879 5.878H5.88c-3.234 0-5.88-2.645-5.88-5.877 0-3.234 2.646-5.879 5.88-5.879l4.626.001c-2.85-.402-5.06-2.865-5.06-5.82C5.446 2.645 8.092 0 11.326 0h24.241z",
  fill: "url(#j)",
  transform: "translate(99 93.311)"
})))));

function SvgImgFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 122,
    viewBox: "0 0 200 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFarm);
export default __webpack_public_path__ + "static/media/img_farm.616a0a7a.svg";
export { ForwardRef as ReactComponent };